import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const allTestimonials = [
// Row 1
[{
  name: 'Mariana',
  location: 'Vicente López, Buenos Aires',
  avatar: 'https://cdn.magicpatterns.com/uploads/roQe97rAwbMr2h7kKrfgZ1/Imagen_21-2-26_a_las_3.37_p._m..jpg',
  text: '"Mi nene tiene TEA y estas recetas son de las pocas que come con ganas. ¡Mil gracias! Ya las recomendé a otras mamás"'
}, {
  name: 'Germán',
  location: 'Ciudad de Córdoba, Córdoba',
  avatar: 'https://cdn.magicpatterns.com/uploads/b97dBr3piZ5ZeG6jAGw7uo/Imagen_21-2-26_a_las_4.03_p._m..jpg',
  text: '"Me sorprendí cuando mi hija me pidió repetir los buñuelos de brócoli. ¡Gracias de verdad!"'
}, {
  name: 'Carmen',
  location: 'Guaymallén, Mendoza',
  avatar: 'https://cdn.magicpatterns.com/uploads/kaM6rXScLsCy5nszwrfrEi/Imagen_21-2-26_a_las_3.59_p._m..jpg',
  text: '"Iván comía re poquito y siempre había que disfrazarle la comida. Este recetario fue clave: es fácil, sano ¡y se lo come todo!"'
}, {
  name: 'Luciana',
  location: 'Rosario, Santa Fe',
  avatar: 'https://cdn.magicpatterns.com/uploads/4dGwaWDTMHhT53BygHpEqH/Imagen_21-2-26_a_las_3.49_p._m..jpg',
  text: '"Nunca pensé que mis hijos iban a pedir más espinaca. ¡Esto es un milagro! Las recetas son súper fáciles y rápidas."'
}, {
  name: 'Sebastián',
  location: 'La Plata, Buenos Aires',
  avatar: 'https://cdn.magicpatterns.com/uploads/qr1m2jextH4ZRQEq8DVyrM/Imagen_21-2-26_a_las_4.08_p._m..jpg',
  text: '"Soy papá soltero y esto me salvó la vida. En 15 minutos tengo algo rico y nutritivo para mis dos nenas."'
}],
// Row 2
[{
  name: 'Valeria',
  location: 'Palermo, Buenos Aires',
  avatar: 'https://cdn.magicpatterns.com/uploads/6k9WRdYv8qLmgCCsVzJaiW/Imagen_21-2-26_a_las_3.56_p._m..jpg',
  text: '"Mi pediatra me felicitó por la variedad de la dieta de Sofía. Le conté del recetario y lo recomendó a otras familias."'
}, {
  name: 'Diego',
  location: 'San Miguel de Tucumán, Tucumán',
  avatar: 'https://cdn.magicpatterns.com/uploads/d8UV9kxm5Am6FYXL6WBLoP/Imagen_21-2-26_a_las_4.14_p._m..jpg',
  text: '"Mis hijos son muy selectivos con la comida. Con estas recetas logramos que coman verduras sin darse cuenta. ¡Increíble!"'
}, {
  name: 'Florencia',
  location: 'Neuquén Capital, Neuquén',
  avatar: 'https://cdn.magicpatterns.com/uploads/d3YB5Pmxg4KZcX4wdpDGbk/Imagen_21-2-26_a_las_3.53_p._m..jpg',
  text: '"El menú semanal imprimible me organizó la vida. Ya no me pregunto qué cocinar, ¡tengo todo planificado!"'
}, {
  name: 'Rodrigo',
  location: 'Mar del Plata, Buenos Aires',
  avatar: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?w=150&h=150&fit=crop&crop=face',
  text: '"La lista de compras hacker es genial. Ahorro tiempo y plata en el super. Mis hijos comen mejor y yo gasto menos."'
}, {
  name: 'Natalia',
  location: 'Salta Capital, Salta',
  avatar: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=150&h=150&fit=crop&crop=face',
  text: '"Compré el recetario con dudas y en una semana ya noté la diferencia. Mis hijos piden las recetas por nombre. ¡Gracias!"'
}],
// Row 3
[{
  name: 'Cecilia',
  location: 'Avellaneda, Buenos Aires',
  avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face',
  text: '"Tengo tres hijos y cada uno tiene sus gustos. Con estas recetas encontré opciones que les gustan a todos. ¡Un alivio!"'
}, {
  name: 'Martín',
  location: 'Córdoba Capital, Córdoba',
  avatar: 'https://cdn.magicpatterns.com/uploads/wVQbZpDqN7zv76mKLbVhtX/Imagen_21-2-26_a_las_4.15_p._m..jpg',
  text: '"Mi hijo rechazaba todo lo verde. Ahora come brócoli, espinaca y zucchini sin quejarse. La técnica del camuflaje funciona."'
}, {
  name: 'Jimena',
  location: 'Mendoza Capital, Mendoza',
  avatar: 'https://cdn.magicpatterns.com/uploads/nQANw4FenAHT9TNECScZhW/Imagen_21-2-26_a_las_4.19_p._m..jpg',
  text: '"Descubrí que mis hijos comen mucho mejor cuando los platos son coloridos y divertidos. Este recetario lo entendió perfecto."'
}, {
  name: 'Pablo',
  location: 'Resistencia, Chaco',
  avatar: 'https://cdn.magicpatterns.com/uploads/h97v5DmA45Uq7AKqrLwMt9/Imagen_21-2-26_a_las_4.20_p._m..jpg',
  text: '"Soy el cocinero de la casa y buscaba ideas nuevas. Este recetario me dio variedad, rapidez y mis hijos piden más. ¡Misión cumplida!"'
}, {
  name: 'Andrea',
  location: 'San Juan Capital, San Juan',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face',
  text: '"Llevaba años luchando con la alimentación de mi hija. Este recetario me dio las herramientas que necesitaba. ¡Vale cada peso!"'
}]];
function TestimonialCard({
  name,
  location,
  avatar,
  text
}: {
  name: string;
  location: string;
  avatar: string;
  text: string;
}) {
  return <div className="flex-shrink-0 w-72 bg-white rounded-2xl p-5 shadow-md border border-gray-100 mx-3" data-id="element-281">
      <div className="flex items-center gap-3 mb-3" data-id="element-282">
        <img src={avatar} alt={name} className="w-12 h-12 rounded-full border-2 border-violet-200 object-cover bg-violet-50" data-id="element-283" />
        <div data-id="element-284">
          <p className="font-extrabold text-violet-600 text-sm" data-id="element-285">{name}</p>
          <p className="text-gray-500 text-xs" data-id="element-286">{location}</p>
        </div>
      </div>
      <div className="flex gap-0.5 mb-2" data-id="element-287">
        {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" data-id="element-288" />)}
      </div>
      <p className="text-gray-700 text-sm leading-relaxed italic" data-id="element-289">{text}</p>
    </div>;
}
function MarqueeRow({
  testimonials,
  reverse = false
}: {
  testimonials: (typeof allTestimonials)[0];
  reverse?: boolean;
}) {
  const doubled = [...testimonials, ...testimonials];
  return <div className="overflow-hidden mb-4" data-id="element-290">
      <motion.div className="flex" animate={{
      x: reverse ? ['0%', '50%'] : ['0%', '-50%']
    }} transition={{
      duration: 30,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-291">
        {doubled.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-292" />)}
      </motion.div>
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-20 bg-gray-50 overflow-hidden" data-id="element-293">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-10" data-id="element-294">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-295">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3" data-id="element-296">
            Lo que dicen <span className="text-gray-900" data-id="element-297">las </span>
            <span className="bg-gradient-to-r from-orange-500 via-violet-600 to-emerald-500 bg-clip-text text-transparent" data-id="element-298">
              mamás y papás
            </span>
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-299">
            {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" data-id="element-300" />)}
            <span className="text-gray-600 font-semibold text-sm ml-1" data-id="element-301">
              4.9/5 (opiniones verificadas)
            </span>
          </div>
        </motion.div>
      </div>

      {/* Scrolling rows */}
      <MarqueeRow testimonials={allTestimonials[0]} data-id="element-302" />
      <MarqueeRow testimonials={allTestimonials[1]} reverse data-id="element-303" />
      <MarqueeRow testimonials={allTestimonials[2]} data-id="element-304" />

      {/* CTA Button */}
      <div className="flex justify-center mt-12" data-id="element-305">
        <motion.button onClick={() => window.open('https://cocinasimpleya.com/cart/53934251802908:1', '_blank')} whileHover={{
        scale: 1.1,
        boxShadow: '0 0 60px rgba(251,191,36,0.9), 0 0 30px rgba(251,146,60,0.8)'
      }} whileTap={{
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 18
      }} className="relative bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 font-extrabold text-xl px-14 py-5 rounded-full shadow-2xl cursor-pointer border-4 border-yellow-200 overflow-hidden group" data-id="element-306">
          <motion.span className="absolute inset-0 bg-gradient-to-r from-yellow-300 via-orange-300 to-yellow-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-307" />
          <span className="relative z-10 flex items-center gap-2" data-id="element-308">
            🛒 ¡COMPRAR AHORA!
          </span>
        </motion.button>
      </div>
    </section>;
}